import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';
import Client from './client';

const Work = ({ clients }) => (
  <Flex
    wrap
    bg="greyExtraLight"
  >
    {clients.map((client) => (
      <Client
        key={client.id}
        {...client}
        path={client.path || `/work/${client.id}/`}
      />
    ))}
  </Flex>
);

Work.propTypes = {
  clients: PropTypes.arrayOf(PropTypes.object),
};

Work.defaultProps = {
  clients: [],
};

export default Work;



// WEBPACK FOOTER //
// ./src/Work/index.js